import React from 'react'
import PropTypes from 'prop-types'
import { Image, Box } from '@chatterbug/aaron'

import Favorite from 'src/ui/Favorite/Favorite'
import { t } from 'src/lib/i18n-react'

import { fallbackAvatarUrl } from './assets'

const TutorAvatar = ({ isFavorite, avatarUrl, name }) => {
  return (
    <>
      <Image
        width="24px"
        height="24px"
        src={avatarUrl || fallbackAvatarUrl}
        backgroundColor="gray88"
        borderRadius="full"
        alt={name ? name : ''}
        flexShrink={0}
      />
      {isFavorite && (
        <Box
          as="span"
          width="11px"
          flexShrink={0}
          sx={{
            marginTop: '-20px',
            marginLeft: '-6px',
          }}
        >
          <Favorite border="white" altText={t('favorite tutor')} />
        </Box>
      )}
    </>
  )
}

TutorAvatar.propTypes = {
  isFavorite: PropTypes.bool,
  avatarUrl: PropTypes.string,
  name: PropTypes.string,
}

export default TutorAvatar
